<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">体験予約</div>

      <div class="card-body">
        <div class="mb-4">
          ＜体験予約までの流れ＞<br>
          お客様情報の入力 ＞ カレンダーページで日程を選択 ＞ 受付完了 ＞ 予約確認のご連絡 ＞ 体験日にご来店
        </div>

        <form @submit.prevent="create">
          <div v-if="Object.keys(errors).length" class="alert alert-danger d-none">
            <ul>
              <template v-for="(value) in Object.values(errors).flat()">
                <li>{{ value }}</li>
              </template>
            </ul>
          </div>

          <dl class="row form-group">
            <dt class="col-md-2">お名前 <span class="text-danger">※</span></dt>
            <dd class="col-md-10">
              <input name="realname" type="text" v-model="member['realname']" class="form-control" required>
              <span v-for="(error, index) in errors.realname" :key="index" class=" invalid-feedback d-block">{{ error }}</span>
            </dd>

            <dt class="col-md-2">ログインID <span class="text-danger">※</span></dt>
            <dd class="col-md-10">
              <input name="name" type="text" v-model="member['name']" class="form-control" required pattern="[-0-9A-Za-z_.]+">
              <span v-for="(error, index) in errors.name" :key="index" class=" invalid-feedback d-block">{{ error }}</span>
              <div class="small text-muted">
                半角英数, -(ハイフン), _(アンダースコア)のみ
              </div>
            </dd>

            <dt class="col-md-2">パスワード <span class="text-danger">※</span></dt>
            <dd class="col-md-10">
              <input name="password" type="text" v-model="member['password']" class="form-control" required pattern="[\x20-\x7E]*" minlength="8">
              <span v-for="(error, index) in errors.password" :key="index" class=" invalid-feedback d-block">{{ error }}</span>
              <div class="small text-muted">
                半角英数記号のみ。8文字以上
              </div>
            </dd>

            <dt class="col-md-2">住所</dt>
            <dd class="col-md-10">
              <input name="address" type="text" v-model="member['address']" class="form-control">
              <span v-for="(error, index) in errors.address" :key="index" class=" invalid-feedback d-block">{{ error }}</span>
            </dd>

            <dt class="col-md-2">電話番号 <span class="text-danger">※</span></dt>
            <dd class="col-md-10">
              <input name="tel" type="text" v-model="member['tel']" required pattern="\d[-\d]+\d" class="form-control">
              <span v-for="(error, index) in errors.tel" :key="index" class=" invalid-feedback d-block">{{ error }}</span>
              <div class="small text-muted">
                半角数字, -(ハイフン)のみ
              </div>
            </dd>

            <dt class="col-md-2">メールアドレス <span class="text-danger">※</span></dt>
            <dd class="col-md-10">
              <input name="email" type="text" v-model="member['email']" :required="member['plan_id'] !== 1" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" class="form-control">
              <span v-for="(error, index) in errors.email" :key="index" class=" invalid-feedback d-block">{{ error }}</span>
            </dd>

            <dt class="col-md-2">
              規約
            </dt>
            <dd class="col-md-10">
              <div>
                ご利用にあたり規約への同意が必要です。規約に同意いただけない場合はご利用いただけません。<br>
                <a href="/terms/" target="_blank">規約ページ</a>を最後までお読みになり、「規約に同意する」にチェックしてください。
              </div>
              <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" name="terms_agreement" id="terms-agreement" required>
                <label class="form-check-label" for="terms-agreement">
                  規約に同意する
                </label>
              </div>
              <div class="mt-2 mb-4 text-danger">
                次の画面でご体験予約へ進みます。ランニング・バイクのご体験は時間指定をさせていただいておりますが、その他の時間帯をご希望の場合はお電話にてお問い合わせくださいませ。
              </div>
            </dd>

            <dt class="col-md-2"></dt>
            <dd class="col-md-10">
              <button dusk="create" type="submit" v-model="member.submit" class="btn btn-success">登録する</button>
            </dd>
          </dl>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";

export default {
  data() {
    return {
      member: {},
      genders: {
        male: '男性',
        female: '女性'
      },
      imageLabel: null,
      uploadFile: null,
      errors: {},
    }
  },
  methods: {
    async create(e) {
      // フォームオブジェクトを生成
      let formData = new FormData();

      // フォーム設定値を追加
      Object.entries(this.member).forEach((value) => {
        formData.append(value[0], value[1]);
      });

      this.$store.commit("loading/setLoading", true);

      await axios.post('/member/api/create', formData)
          .then(async response => {
            this.$toasted.show('登録を完了しました');
            this.errors = {};

            // ログイン中ユーザを確認
            await store.dispatch('auth/currentUser');

            // ユーザトップページへ移動
            await this.$router.push(`/member`);
          })
          .catch((error) => {
                const {data, status, statusText} = error.response;
                if (status === 422) {
                  this.errors = data.errors;
                } else {
                  this.errors = {};
                  this.$store.state.error.code = error.response.status;
                }
              }
          );

      this.$store.commit("loading/setLoading", false);
    },
  },
}
</script>
